import {PAGES} from "../../../../../core/consts";
import {BaseLinkModel} from "../../../../../infrastructure/models/link/base-link-model";
import {CompetitorLinkParams} from "../../../models/competitor-link-params";

export class CompetitorStandingsPageLinkModel extends BaseLinkModel  {
  constructor(competitorId, sportName, competitorName, page, hashParams, isFollow: Boolean = true) {
    super(PAGES.COMPETITOR.standings, new CompetitorLinkParams(competitorId, sportName, competitorName), false, null, null, hashParams);

    this.isFollow = isFollow;
  }
}